import React from 'react'
import BistroMenuItem from './BistroMenuItem'
import bistromenuStyles from './bistromenu.module.sass'

export default props => {
  const { menu, sectionsRef } = props
  const anchor = menu.type.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')
  return (
    menu.items && (
      <div className={bistromenuStyles.bistromenu}>
        <h3 className={bistromenuStyles.type}>
          <a
            className={bistromenuStyles.sectionhref}
            href={`#${anchor}`}
            name={`#${menu.type}`}
            // eslint-disable-next-line no-return-assign
            ref={el => (sectionsRef.current[anchor] = el)}
          >
            {menu.type}
          </a>
        </h3>
        <p className={bistromenuStyles.intro}>{menu.intro}</p>
        <ul className={bistromenuStyles.list}>
          {menu.items.map(item => (
            <BistroMenuItem item={item} key={item.item_name} />
          ))}
        </ul>
      </div>
    )
  )
}
